import React from "react";
import { useNavigate } from "react-router-dom";
import "./HolidayDashboard.css";
import Header from "../Common/Layout/Header";
import { useAuth } from "../Common/Configurations/AuthContext";
import DMCPackageTab from "../Components/AllTabs/DMCPackageTab";

const HolidayDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Statistics Data
  const holidayStats = [
    { title: "Total Packages", value: "48", icon: "🎁", color: "holidaydb-blue" },
    { title: "Bookings", value: "1,245", icon: "📅", color: "holidaydb-green" },
    { title: "Revenue", value: "INR 42.8L", icon: "💰", color: "holidaydb-purple" },
    { title: "Customers", value: "892", icon: "👥", color: "holidaydb-pink" },
    { title: "Destinations", value: "12", icon: "🌍", color: "holidaydb-cyan" },
    { title: "Agents", value: "24", icon: "👨‍💼", color: "holidaydb-amber" },
  ];

  // Table Data
  const holidayPackages = [
    { id: "HP-001", name: "John Smith", passport: "A12345678", packageType: "Europe Grand Tour", country: "USA", submissionDate: "Nov 15, 2023", status: "active", travelers: 2, duration: "14 Days", fee: "INR 1,49,999" },
    { id: "HP-002", name: "Maria Garcia", passport: "B87654321", packageType: "Asian Adventure", country: "UK", submissionDate: "Nov 14, 2023", status: "confirmed", travelers: 4, duration: "10 Days", fee: "INR 89,999" },
  ];

  // Pie Chart Data
  const pieChartData = [
    { country: "Europe", value: 320, color: "#2563eb", percentage: 32 },
    { country: "Asia", value: 280, color: "#10b981", percentage: 28 },
    { country: "USA", value: 240, color: "#8b5cf6", percentage: 24 },
    { country: "Middle East", value: 120, color: "#f59e0b", percentage: 12 },
    { country: "Australia", value: 40, color: "#ec4899", percentage: 4 },
  ];

  const createPieChart = () => {
    let accumulatedAngle = 0;
    return pieChartData.map((item) => {
      const startAngle = accumulatedAngle;
      const endAngle = startAngle + (item.percentage / 100) * 360;
      accumulatedAngle = endAngle;
      const startRad = (startAngle - 90) * (Math.PI / 180);
      const endRad = (endAngle - 90) * (Math.PI / 180);
      const x1 = 50 + 50 * Math.cos(startRad);
      const y1 = 50 + 50 * Math.sin(startRad);
      const x2 = 50 + 50 * Math.cos(endRad);
      const y2 = 50 + 50 * Math.sin(endRad);
      const largeArc = endAngle - startAngle > 180 ? 1 : 0;
      const pathData = [`M 50 50`, `L ${x1} ${y1}`, `A 50 50 0 ${largeArc} 1 ${x2} ${y2}`, `Z`].join(" ");
      return { ...item, pathData };
    });
  };

  const pieSegments = createPieChart();
  const handleNavigation = (path) => navigate(path);

  return (
    <div className="holidaydb-main-layout">
      <Header User={user} activeSection="holidays"/>
      <div className="p-2">
                  {/* <DMCPackageTab pageName="HOLIDAYDASHBOARD" /> */}
                </div>
      <div className="holidaydb-wrapper">
        <div className="container-fluid">
          
          {/* Top Header Section */}
          <div className="holidaydb-top-bar d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="holidaydb-page-title">Holiday Management</h2>
              <p className="holidaydb-page-subtitle">Welcome back! Here is what's happening today.</p>
            </div>
            <div className="holidaydb-header-actions">
              <button className="holidaydb-btn holidaydb-btn-primary" onClick={() => handleNavigation("/dmcpackagecreate")}>
                <span className="me-2">＋</span> Create New Package
              </button>
              <button className="holidaydb-btn holidaydb-btn-white ms-3" onClick={() => handleNavigation("/enquirylist")}>
                <span className="me-2">📅</span> View Bookings
              </button>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="row g-3 mb-4">
            {holidayStats.map((stat, index) => (
              <div key={index} className="col-md-4 col-lg-2">
                <div className="holidaydb-stat-card">
                  <div className={`holidaydb-stat-icon-wrapper ${stat.color}`}>
                    {stat.icon}
                  </div>
                  <div className="holidaydb-stat-details">
                    <p className="holidaydb-stat-label">{stat.title}</p>
                    <h3 className="holidaydb-stat-value">{stat.value}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row g-4">
            {/* Table Section */}
            <div className="col-xl-8">
              <div className="holidaydb-card">
                <div className="holidaydb-card-header d-flex justify-content-between align-items-center">
                  <h4 className="holidaydb-card-title">Recent Package Requests</h4>
                  <button className="holidaydb-text-btn" onClick={() => handleNavigation("/packageslist")}>See all</button>
                </div>
                <div className="holidaydb-table-wrapper">
                  <table className="holidaydb-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Customer Details</th>
                        <th>Package Info</th>
                        <th>Status</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {holidayPackages.map((pkg, index) => (
                        <tr key={index}>
                          <td><span className="holidaydb-badge-id">{pkg.id}</span></td>
                          <td>
                            <div className="holidaydb-user-name">{pkg.name}</div>
                            <div className="holidaydb-user-sub">Passport: {pkg.passport}</div>
                          </td>
                          <td>
                            <div className="holidaydb-pkg-name">{pkg.packageType}</div>
                            <div className="holidaydb-pkg-country">{pkg.country} • {pkg.duration}</div>
                          </td>
                          <td>
                            <span className={`holidaydb-status-pill ${pkg.status}`}>
                              {pkg.status}
                            </span>
                          </td>
                          <td className="holidaydb-pkg-fee">{pkg.fee}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Chart Section */}
            <div className="col-xl-4">
              <div className="holidaydb-card">
                <div className="holidaydb-card-header">
                  <h4 className="holidaydb-card-title">Destination Traffic</h4>
                </div>
                <div className="holidaydb-chart-container text-center py-4">
                  <div className="holidaydb-svg-box">
                    <svg width="180" height="180" viewBox="0 0 100 100">
                      {pieSegments.map((segment, index) => (
                        <path key={index} d={segment.pathData} fill={segment.color} />
                      ))}
                      <circle cx="50" cy="50" r="30" fill="white" />
                    </svg>
                  </div>
                  <div className="holidaydb-legend-list mt-4">
                    {pieChartData.map((item, index) => (
                      <div key={index} className="holidaydb-legend-item d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <span className="holidaydb-legend-color" style={{ backgroundColor: item.color }}></span>
                          <span className="holidaydb-legend-name">{item.country}</span>
                        </div>
                        <span className="holidaydb-legend-val">{item.percentage}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayDashboard;